/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Operasional_D3tInputs */

const en_mk_sol_operasional_d3t = /** @type {(inputs: Mk_Sol_Operasional_D3tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exceptions escalate to a person rather than being decided alone`)
};

const id_mk_sol_operasional_d3t = /** @type {(inputs: Mk_Sol_Operasional_D3tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyimpangan naik ke manusia, bukan diputuskan sendiri`)
};

/**
* | output |
* | --- |
* | "Exceptions escalate to a person rather than being decided alone" |
*
* @param {Mk_Sol_Operasional_D3tInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_operasional_d3t = /** @type {((inputs?: Mk_Sol_Operasional_D3tInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Operasional_D3tInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_operasional_d3t(inputs)
	return en_mk_sol_operasional_d3t(inputs)
});